<template>
  <div v-if="loaded">
    {{ extension }}
    <badge-group-component :users="users"/>
  </div>
</template>

<script>
import userApi from "~/api/user";
import BadgeGroupComponent from "./BadgeGroupComponent";

export default {
  name: "UsersByExtensionComponent",
  components: {BadgeGroupComponent},
  props: {
    extension: {
      type: String,
      required: true
    },
    displayName: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      users: [],
      loaded: false,
    }
  },
  mounted() {
    if (this.extension.length > 0) {
      userApi.getByExtension(this.extension).then(response => {
        this.users = response.data;
      }).finally(() => {
        this.loaded = true;
      });
    } else {
      this.loaded = true;
    }
  }
}
</script>